import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AssassinsHideout4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASSASINS_HIDEOUT4;
}

export default AssassinsHideout4PoiTileEntity;
